<template>
  <tr class="team-row">
    <td>{{ email }}</td>
    <td>
      <select-field
        label=""
        :options="roles"
        :value="role"
        :disabled="email == loggedUserEmail"
        @change="setRoleToMember"
      />
    </td>
    <td>
      <button
        class="button is-danger is-outlined"
        @click="removeTeamMember(email)"
        :disabled="email == loggedUserEmail"
      >
        {{ $t("Remove") }}
      </button>
    </td>
    <td>
      <field-message :success="$t(successMsg)" :failure="$t(failureMsg)" />
    </td>
  </tr>
</template>

<script>
import { state } from "@/store"
import { SelectField, FieldMessage } from "@/components/form"

export default {
  name: "team-row",
  props: ["email", "roles", "role", "failureMsg", "successMsg"],
  components: {
    SelectField,
    FieldMessage
  },
  computed: {
    loggedUserEmail() {
      return state.user.email
    }
  },
  methods: {
    setRoleToMember(role) {
      this.$emit("changeRole", this.email, role)
    },
    removeTeamMember() {
      this.$emit("delete", this.email)
    }
  }
}
</script>

<style lang="scss">
.team-row {
  td:first-child {
    line-height: 2.3rem;
  }
  td:last-child {
    border: none;
    line-height: 2.3rem;
  }
}
</style>
